import { memo, useContext, useMemo } from 'react'

import AppsVersionContext from 'components/contexts/AppsVersionContext'
import config from 'config'
import { SubAppRouteConfig } from 'types/SubAppRouteConfig'
import { joinUrl } from 'utils'
import ModuleFederationMount from 'utils/ModuleFederationMount'

const useContactsConfig = () => {
  const { contactsTargetBuild } = useContext(AppsVersionContext)
  const uccUnifiedAdminContactsConfiguration = useMemo(
    () => ({
      ...config.subAppsModuleFederation.uccUnifiedAdminContacts,
      url: joinUrl(config.subAppsModuleFederation.uccUnifiedAdminContacts.url, contactsTargetBuild),
    }),
    [contactsTargetBuild],
  )

  return {
    uccUnifiedAdminContactsConfiguration,
  }
}

interface ContactsConfigurationRoutesComponentProps {
  uccUnifiedAdminContactsConfiguration: any
}

const ContactsRoutesComponent = memo(
  ({ uccUnifiedAdminContactsConfiguration }: ContactsConfigurationRoutesComponentProps) => {
    return (
      <ModuleFederationMount
        module="contactsApp"
        subAppModuleFederation={uccUnifiedAdminContactsConfiguration}
        key="contactsApp"
      />
    )
  },
)

const useContactsRoutes = (path: string): SubAppRouteConfig => {
  const { uccUnifiedAdminContactsConfiguration } = useContactsConfig()

  return {
    paths: config.subAppsModuleFederation.uccUnifiedAdminContacts.routes?.map((route) => `${path}/${route}`) ?? [],
    component: () => (
      <ContactsRoutesComponent uccUnifiedAdminContactsConfiguration={uccUnifiedAdminContactsConfiguration} />
    ),
  }
}

export default useContactsRoutes
